import { createStore } from "vuex";
import { CODE_BEIKE_1, CODE_BEIKE_2, CODE_BEIKE_3 } from "@/utils/constant";
import { getImagePath } from "@/utils/getImage";
import ataIcon from "@/img/ata-icon.png";
import homeBanner from "@/img/homebg.png";

export default createStore({
  state: {
    // 考试code
    testCode: "",
    // code
    projectCode: "",
    // 是否是贝壳
    credentialsID: "",
    // 批次id
    batchCode: "",
    // 考生准考证号
    perm: "",
    // 科目名
    subjectName: "",
    // 商品信息对象
    productMsg: {},
    // 项目名
    projectName: "",
    // 项目类型
    authType: "",
  },
  getters: {
    isBeike(state) {
      return (
        state.testCode === CODE_BEIKE_1 ||
        state.testCode === CODE_BEIKE_2 ||
        state.testCode === CODE_BEIKE_3
      );
    },
    logo(state) {
      return getImagePath(state.testCode, "logo") || ataIcon;
    },
    loginBG(state) {
      return getImagePath(state.testCode, "login") || "";
    },
    banner(state) {
      return getImagePath(state.testCode, "banner") || "";
    },
    bannerWeb(state) {
      return getImagePath(state.testCode, "banner_web") || homeBanner;
    },
  },
  mutations: {
    saveTestCode(state, testCode) {
      state.testCode = testCode;
    },
    setProjectCode(state, projectCode) {
      state.projectCode = projectCode;
    },
    saveCredentialsID(state, credentialsID) {
      state.credentialsID = credentialsID;
    },
    saveBatchCode(state, batchCode) {
      state.batchCode = batchCode;
    },
    savePerm(state, perm) {
      state.perm = perm;
    },
    saveSubject(state, subjectName) {
      state.subjectName = subjectName;
    },
    // 保存商品信息对象
    saveProductObj(state, obj) {
      state.productMsg = obj;
    },
    // 保存项目名
    saveProjectName(state, projectName) {
      state.projectName = projectName;
    },
    // 保存项目类型
    saveAuthType(state, authType) {
      state.authType = authType;
    },
  },
  actions: {},
  modules: {},
});
